import { MemberList } from 'ui/components/agent/patterns/MemberList/MemberList';

/**
 * 仲介業者メンバー一覧
 */
export const AgentMemberList: React.FC = () => {
    return <MemberList />;
};
